<template>
  <el-drawer
    :visible.sync="drawerVisible"
    :with-header="false"
    size="500px"
    direction="rtl"
    :before-close="handleClose"
  >
    <div class="ad-group-detail-container">
      <div class="drawer-header">
        <div class="drawer-title">广告组详情</div>
        <i class="el-icon-close close-icon" @click="handleClose"></i>
      </div>

      <div class="detail-content" v-loading="loading">
        <div class="section">
          <div class="section-title">基本信息</div>
          <div class="detail-item">
            <div class="item-label">广告组名称</div>
            <div class="item-value">{{ adGroupInfo.name || '-' }}</div>
          </div>
          <!--          <div class="detail-item">-->
          <!--            <div class="item-label">广告位置</div>-->
          <!--            <div class="item-value">{{ adGroupInfo.locationName || '乘客端底部' }}</div>-->
          <!--          </div>-->
          <div class="detail-item">
            <div class="item-label">位置模板</div>
            <div class="item-value">{{ adGroupInfo.adTemplateName || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">展示界面</div>
            <div class="item-value">{{ pageTitle }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">权重</div>
            <div class="item-value">{{ adGroupInfo.weights || '-' }}</div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">其他信息</div>
          <div class="detail-item">
            <div class="item-label">创建人</div>
            <div class="item-value">{{ adGroupInfo.createUserName || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">创建时间</div>
            <div class="item-value">{{ adGroupInfo.createTime || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">审核人</div>
            <div class="item-value">{{ adGroupInfo.auditUserName || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">审核时间</div>
            <div class="item-value">{{ adGroupInfo.auditTime || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">更新人</div>
            <div class="item-value">{{ adGroupInfo.updateUserName || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">更新时间</div>
            <div class="item-value">{{ adGroupInfo.updateTime || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">状态</div>
            <div class="item-value">
              <span :class="['status-text', `status-${adGroupInfo.state}`]">
                {{ adGroupInfo.stateStr || '-' }}
              </span>
            </div>
          </div>
          <div class="detail-item" v-if="adGroupInfo.state === 2">
            <div class="item-label">拒绝原因</div>
            <div class="item-value red-text">{{ adGroupInfo.rejectReason }}</div>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
  import { getAdGroupDetail } from '@/api/marketing/adGroup'
  import { getPageEnumList } from '../../../../api/marketing/advertising'

  export default {
    name: 'AdGroupDetail',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      adGroupId: {
        type: [String, Number],
        default: ''
      }
    },
    data() {
      return {
        loading: false,
        adGroupInfo: {},
        pageEnumList: []
      }
    },
    created() {
      getPageEnumList().then((res) => {
        const { code, data } = res
        if (code === 0) {
          this.pageEnumList = data.bannerDisplayPage || []
        }
      })
    },
    computed: {
      drawerVisible: {
        get() {
          return this.visible
        },
        set(val) {
          this.$emit('update:visible', val)
        }
      },
      pageTitle() {
        const { displayPage } = this.adGroupInfo
        const item = this.pageEnumList.find((item) => item.value === displayPage)
        return item ? item.label : '-'
      }
    },
    watch: {
      visible(val) {
        if (val && this.adGroupId) {
          this.getDetail()
        }
      }
    },
    methods: {
      handleClose() {
        this.drawerVisible = false
      },
      async getDetail() {
        if (!this.adGroupId) return
        this.loading = true
        try {
          const res = await getAdGroupDetail(this.adGroupId)
          if (res.data) {
            this.adGroupInfo = res.data
          }
        } catch (error) {
          this.$message.error('获取广告组详情失败')
          console.error('获取广告组详情失败:', error)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ad-group-detail-container {
    height: 100%;
    display: flex;
    flex-direction: column;

    .drawer-header {
      padding: 16px 20px;
      border-bottom: 1px solid #ebeef5;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .drawer-title {
        font-size: 16px;
        font-weight: 500;
        color: #303133;
      }

      .close-icon {
        font-size: 18px;
        cursor: pointer;
        color: #909399;

        &:hover {
          color: #409eff;
        }
      }
    }

    .detail-content {
      flex: 1;
      padding: 20px;
      overflow-y: auto;

      .section {
        margin-bottom: 24px;

        .section-title {
          font-size: 15px;
          font-weight: 500;
          color: #303133;
          margin-bottom: 16px;
          position: relative;
          padding-left: 10px;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 14px;
            background-color: #409eff;
            border-radius: 2px;
          }
        }

        .detail-item {
          display: flex;
          margin-bottom: 12px;
          font-size: 14px;
          line-height: 1.5;

          .item-label {
            width: 100px;
            color: #606266;
            flex-shrink: 0;
          }

          .item-value {
            color: #303133;
            word-break: break-all;
          }
        }
      }
    }
  }

  .red-text {
    color: #f56c6c;
  }

  .status-text {
    display: inline-block;
    padding: 0 10px;
    height: 24px;
    line-height: 22px;
    font-size: 12px;
    border-radius: 12px;
    box-sizing: border-box;
    white-space: nowrap;

    &.status-0 {
      color: #909399;
      background-color: rgba(144, 147, 153, 0.1);
      border: 1px solid rgba(144, 147, 153, 0.2);
    }

    &.status-1 {
      color: #e6a23c;
      background-color: rgba(230, 162, 60, 0.1);
      border: 1px solid rgba(230, 162, 60, 0.2);
    }

    &.status-2 {
      color: #f56c6c;
      background-color: rgba(245, 108, 108, 0.1);
      border: 1px solid rgba(245, 108, 108, 0.2);
    }

    &.status-3 {
      color: #67c23a;
      background-color: rgba(103, 194, 58, 0.1);
      border: 1px solid rgba(103, 194, 58, 0.2);
    }

    &.status-4 {
      color: #909399;
      background-color: rgba(144, 147, 153, 0.1);
      border: 1px solid rgba(144, 147, 153, 0.2);
    }
  }
</style>
